import { Observable } from "rxjs";
import { AppSettings } from "./models/app-config";
import { AppConfigService } from "./services/app-config.service";

export function initializeAppConfig(appConfigService: AppConfigService): () => Observable<AppSettings> {
    return () => appConfigService.loadAppConfig();
}